import { useLocation } from "react-router-dom";
import { StudentContent, StudentDetails } from "../../components/app";

export default function Student() {
  let location = useLocation();

  return (
    <>
      {location.state ? (
        location.state.page === "detail" ? (
          <StudentDetails dataId={location.state.dataId} />
        ) : (
          <StudentContent />
        )
      ) : (
        <StudentContent />
      )}
    </>
  );
}
